import { render } from "./_MainNews.vue?vue&type=template&id=44d97dee"
import script from "./_MainNews.vue?vue&type=script&lang=js"
export * from "./_MainNews.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__